
import { createContext } from "react";

import { Trial } from "@/apis/dtos";
import useGetTrials from "@/hooks/data/useGetTrials";

export interface ITrialsContext extends Omit<ReturnType<typeof useGetTrials>, 'data' | 'total' | 'offset'> {
    data?: Trial[]
}

export const TrialsContext = createContext<ITrialsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TrialsContext;